import React, { useState } from 'react';
import Footer from '../components/Footer';
import { AlertTriangle, Send } from 'lucide-react';
import Header from '../components/Header';

const DeleteAccountPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    reason: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 1500));
    setIsSubmitting(false);
    setIsSubmitted(true);
    setFormData({ email: '', phone: '', reason: '' });
    setTimeout(() => setIsSubmitted(false), 5000);
  };

  return (
    <div className="min-h-screen flex flex-col bg-surface-muted">
      <Header />
      <main className="flex-1 py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10 animate-floatUp text-center">
            <h1 className="text-h1 text-ink-900">
              Request Account Deletion
            </h1>
            <p className="mt-4 max-w-2xl mx-auto text-lg text-ink-500">
              Please provide your contact details and the reason for deletion. Our team will process your request promptly.
            </p>
          </div>

          <div className="lk-card overflow-hidden">
            <div className="bg-brand-secondary/10 border-b border-brand-secondary/20 p-6 sm:p-8 flex items-start gap-4">
              <div className="h-10 w-10 rounded-full bg-brand-secondary/10 flex items-center justify-center">
                <AlertTriangle className="h-5 w-5 text-brand-secondary" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-brand-secondary">Important</h2>
                <p className="text-sm text-brand-secondary mt-1">
                  Deleting your account is permanent and cannot be undone. Please ensure you've backed up any important information.
                </p>
              </div>
            </div>

            <div className="p-8 sm:p-10">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-ink-700">Email Address</label>
                  <input type="email" name="email" id="email" required value={formData.email} onChange={handleChange} placeholder="you@example.com" className="lk-input mt-1.5" />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-ink-700">Phone</label>
                  <input type="tel" name="phone" id="phone" required value={formData.phone} onChange={handleChange} placeholder="+91-9876543210" className="lk-input mt-1.5" />
                </div>
                <div>
                  <label htmlFor="reason" className="block text-sm font-medium text-ink-700">Reason for deletion</label>
                  <textarea name="reason" id="reason" rows="4" required value={formData.reason} onChange={handleChange} placeholder="I no longer use this service" className="lk-input mt-1.5"></textarea>
                </div>
                <div>
                  <button type="submit" disabled={isSubmitting} className="lk-btn-primary w-full">
                    {isSubmitting ? (
                      <>
                        <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" aria-hidden="true" />
                        <span>Submitting...</span>
                      </>
                    ) : (
                      <>
                        <Send className="h-4 w-4" aria-hidden="true" />
                        Request Deletion
                      </>
                    )}
                  </button>
                </div>
                {isSubmitted && (
                  <div role="status" className="rounded-xl border border-success/20 bg-success-tint p-3 text-center text-sm font-medium text-success">
                    Your request has been received. We will reach out to confirm and process the deletion.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DeleteAccountPage;
